<template>
  <div>
    <div class="holdertit">A total of {{ Number(totalNFT).toLocaleString() }} tokens found</div>
    <div>
      <div class="Block_list">
        <div class="Block_box" v-for="(item, index) in inventoryList" :key="index">
          <!-- <img src="../../../assets/pc/Index/active.png" /> -->
          <img :src="item.image" />
          <div class="tit" @click="TackeId(index)">TokenID : <span>{{ item.tokenId }}</span></div>
          <div class="cont" @click="Tacke(index)">Owner : <span>{{ item.ownerAddress1 }}</span></div>
        </div>
 
      </div>

      <div class="Block_List_Bottom" v-if="inventoryList.length>0">
        <el-pagination
          ref="Pagination"
          :current-page.sync="PaginationIndex"
          background
            :page-size="20"
          layout="prev, pager,
      next"
          @current-change="CurrentChange"
          :total="total1"
        >
        </el-pagination>
      </div>
      <div v-show="inventoryList.length <= 0">
        <EmptyState />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../BlockList/Pagination";
import Pagination2 from "../BlockList/Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import { BlockList } from "@/assets/server/api";
import { timestampConvertTime } from "@/utils/utils";
import { goPAGE, formatSeconds, listType, getSubStr } from "@/utils/utils";
export default {
  props: ["inventoryList",'totalNFT','contractAddress','PaginationIndex'],
  data() {
    return {
     // PaginationIndex: 1,
      total1: null,
      nowLang: "",
      TimeDate: [],
      Page1: "",
      //contractAddress:'',
    
    };
  },
  components: {
    Pagination,
    EmptyState,
    Pagination2,
  },
  watch: {
    deep: true,
    totalNFT(val) {
   //  console.log(val);
     this.total1=val;
    },
    contractAddress(val){
      this.contractAddress=val;
  //    console.log(this.contractAddress);
    },
    PaginationIndex(val){
      this.PaginationIndex=val;
    }
  },
  mounted() {
    this.PaginationIndex = 1;
   //this.blockList();
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  methods: {
    CurrentChange(val) {
     // console.log(val);
      this.PaginationIndex = val;
     
    this.$emit('getDatepage',val);
    },
    Tacke(Index) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.inventoryList[Index].ownerAddress },
      });
      // let params = {
      //   contractAddress: this.inventoryList[Index].tfscOwner,
      // };
      // console.log(params);
      // this.$router.push({ path: "/pc/NFTsdetail", query: params });
    },
    TackeId(Index) {
   //   console.log(Index);
      let params = {
        contractAddress: this.contractAddress,
        tokenId:this.inventoryList[Index].tokenId
      };
   //   console.log(params);
      this.$router.push({ path: "/pc/NFTslistdetail", query: params });
    },
    async blockList() {
      this.Page1 = 1;
      const params = {
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      await BlockList(formData).then((res) => {
        this.list = res.result.tradeList;
        this.total1 = res.result.total;
        this.index = 1;
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < this.list.length; i++) {
          let UTCTime =
            res.result.tradeList[i].tradeTime -
            this.getClientTimezone * 3600000;
          this.TimeDate[i] = timestampConvertTime(UTCTime);
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );

          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
        }
      });
    },
    Block(index) {
      this.$router.push({
        path: "/pc/BkHeight",
        query: { height: index },
      });
    },
    Hash(index) {
      this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
 
  },
};
</script>

<style lang="less" scoped>
.holdertit {
  font-size: 14px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #898b8d;
  line-height: 20px;
}
.Block_list {
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .Block_box {
    margin-right: 16px;
    margin-top: 20px;
    img {
      width: 208px;
      min-height:181px;
      // height: 181px;
      background: #1c1e24;
      border-radius: 14px 14px 14px 14px;
      opacity: 1;
    }
    .tit {
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      line-height: 17px;
      margin-top: 12px;
      span{
        color: #ffffff;
        cursor: pointer;
      }
    }
    .cont {
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      line-height: 17px;
      margin-top: 12px;
      span{
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}

.Block_List_Bottom {
  margin-top: 100px;
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color:#fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252E !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
